import Template from "../Template";
import "../../styles/stores/storeHome.css";
import StoreNameandInfo from "../../components/StoreNameandInfo";
import StoreTabs from "../../components/tabs/StoreTabs";
import Transaction from "./makeTansaction/Transactaction";
import ReceivedOrder from "./receivedOrder/ReceivedOrder";
import AdvertismentHomePage from "./Advert/AdvertismentHomePage";
import StockHomePage from "./stockManagement/StockHomePage";
import MessagesPage from "./messages/MessagesPage";
import StoreProfile from "./storeProfile/StoreProfile";
import { createProductUrl, fetchStoreTransactionUrl, getStoreUrl } from "../../api/endpoints";
import { useNavigate, useParams } from "react-router-dom";
import { setPage, setStore } from "../../slice/storeSlice.js";
import { updateNotification } from "../../slice/notificationSlice";
import { useDispatch, useSelector } from "react-redux";

import CashTransaction from "./makeTansaction/CashTransaction";
import Expenses from "./expenses/Expenses";
import { useEffect, useState, useMemo, useRef } from "react";
import { io } from "socket.io-client";
import Spinner from "../../components/uxCollections/Loaders";
import CheckSales from "./makeTansaction/checkSales/CheckSales";
import CheckStock from "./stockManagement/CheckStock";
import BlockNotification from "../notification/BlockNotification.js";
import { refreshUserToken } from "../../tools/refreshToken.js";
import { saveData } from "../../tools/indexdb.js";
import { syncOfflineQueue } from "../../tools/synOfflineQueue.js";
import { setIsSyncOnGoing } from "../../slice/offlineQueue.js";
import PromptToSync from "../../components/alerts/promptToSync.js";
import StoreDashboard from "./storeProfile/StoreProfileNew.jsx";
import ExpenseTracker from "./expenses/ExpensesNew.jsx";
import { uiAlert } from "../../components/alerts/customAlert/uiAlert.js";

const StoreHome = ({ setOpenPromptToSync }) => {
  /* const [page, setPage] = useState(); */
  const [openCheckSales, setOpenCheckSales] = useState(false); // to show the check sales component
  const [openCheckStock, setOpenCheckStock] = useState(false); // to show the check stock component
  const [refetch, setRefetch] = useState(false); // to refetch the data after a new order is received
  const [isLoading, setIsLoading] = useState(true);
  const [showBlockNotification, setShowBlockNotification] = useState(false);
  const [reminderData, setReminderData] = useState(null); // to show the reminder data
  const [noProductCreated, setNoProductCreated] = useState(false); // to manipulate the tab

  const [loadingState, setLoadingState] = useState("Syncing store");
  const { storeID } = useParams();
  const { user } = useSelector((state) => state.webStoreUser);
  const { store } = useSelector((state) => state.store);
  const { page } = useSelector((state) => state.store);
  const { count, queue } = useSelector((state) => state.offlineQueue);
  const [isDbReady, setIsDbReady] = useState(false);

  const socket = useMemo(() => io(process.env.REACT_APP_Back_end_api_root, { transports: ["websocket"] }), []); /* auth can be provided */
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const countRef = useRef(count);

  useEffect(() => {
    console.log(loadingState);

    countRef.current = count;
  }, [count, loadingState]);

  useEffect(() => {
    /*  setLoadingState("Syncing store"); */
    let syncInterval = setInterval(() => {
      /* check if store is out of sync and sync after every 2 hours */
      if (countRef.current) {
        /* prompt to sync store*/
        setOpenPromptToSync(true);
        console.log("prompt to sync store");
      }
    }, 1800000); /* 30 minutes interval */

    /* check if there is pending syn and syn before initailzing store */
    /*   if (count) {
      try {
        syncOfflineQueue();
        console.log("syncing store since count is greater than 0");
      } catch (error) {
        console.log(error);
      }
    }

  
    fetchStore(); */
    const run = async () => {
      try {
        if (count) {
          dispatch(setIsSyncOnGoing(false));
          try {
            await syncOfflineQueue();
            console.log("syncing store since count is greater than 0");
          } catch (error) {
            console.log(error, "error syncing offline queue before initializing store");
          }
        }

        await fetchStore();
      } catch (error) {
        console.log(error);
      }
    };

    run();

    socket.on("connect", () => {
      console.log(socket.id); // x8WIv7-mJelg7on_ALbx
      socket.emit("createRoom", storeID);
    });
    socket.on("newMessage", (message, sender) => {
      console.log(message, sender);
      uiAlert("new message received", "info");
      dispatch(updateNotification(true));
    });
    socket.on("newOrderReceived", () => {
      uiAlert("new order received Eyo", "info");
      setRefetch((prev) => !prev);
      dispatch(updateNotification(true));
    });
    socket.on("newDisputeRaised", ({ room, item, disputeReason }) => {
      uiAlert("new dispute raised on " + item + " because " + disputeReason);
      setRefetch((prev) => !prev);
      dispatch(updateNotification(true));
    });
    socket.on("disputeResolved", ({ room, item }) => {
      uiAlert("dispute resolved on " + item);
      setRefetch((prev) => !prev);
      dispatch(updateNotification(true));
    });
    socket.on("reminder", (data) => {
      setReminderData(data);
      setShowBlockNotification(true);
      dispatch(updateNotification(true));
    });

    return () => {
      console.log("store home unmounted", countRef.current);

      countRef.current && setOpenPromptToSync(true);
      clearInterval(syncInterval);
      socket.off("connect");
      socket.off("newMessage");
      socket.off("newOrderReceived");
      socket.off("newDisputeRaised");
      socket.off("disputeResolved");
      socket.off("reminder");
      setIsDbReady(false);
      dispatch(setPage(null));
      socket.disconnect();
    };
  }, []);

  const fetchStore = async () => {
    setLoadingState("Fetching store");
    let accessToken = localStorage.getItem("accessToken");

    try {
      const response = await fetch(getStoreUrl + storeID, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (response.ok) {
        const store = await response.json();
        dispatch(setStore(store));

        if (store.isOnlineStoreOnly) {
          // let todayTransactions = await fetchTodayTransaction(store);
          let storeProductCollection = await fetchProducts(store);
          let storeData = { store, todayTransactions: null, storeProductCollection };
          await saveData(store.storeName, storeData);

          // check if stores contains no products
          if (storeProductCollection.length === 0) {
            dispatch(setPage("stockManagement"));
            // setPage("stockManagement");
            setNoProductCreated(true);
          } else {
            //  setPage("receivedOrder");
            dispatch(setPage("receivedOrder"));
          }
          setLoadingState(null);
        } else {
          setLoadingState("Configuring store");
          /*  let todayTransactions = await fetchTodayTransaction(store);
          let storeProductCollection = await fetchProducts(store); */

          const [todayTransactions, storeProductCollection] = await Promise.all([fetchTodayTransaction(store), fetchProducts(store)]);

          let storeData = { store, todayTransactions, storeProductCollection };
          console.log(storeData, "store data");

          let dbSTATE = await saveData(store.storeName, storeData);

          console.log(dbSTATE, "db state after saving");

          // check if stores contains no products
          if (storeProductCollection.length === 0) {
            dispatch(setPage("stockManagement"));
            // setPage("stockManagement");
            setNoProductCreated(true);
          }
          if (dbSTATE) {
            console.warn("store synced successfully, setting the page to transaction");
            setIsDbReady(true);

            /*   setTimeout(() => {
            }, 1000); */
            dispatch(setPage("transaction"));
          }

          setLoadingState(null);
        }

        setIsLoading(false);
      } else if (response.status === 400) {
        refreshUserToken(getStoreUrl + storeID, fetchStore, navigate);
      } else {
        uiAlert("something went wrong", "error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsLoading(false);
      setLoadingState(null);
    }
  };

  const fetchTodayTransaction = async (store) => {
    let accessToken = localStorage.getItem("accessToken");
    let storeId = store._id;
    try {
      let response = await fetch(fetchStoreTransactionUrl + storeId, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });

      if (response.ok) {
        let transactionData = await response.json();

        return transactionData;
      } else if (response.status === 404) {
        return [];
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  const fetchProducts = async (store) => {
    let accessToken = localStorage.getItem("accessToken");
    try {
      let response = await fetch(createProductUrl + store._id, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
      });
      if (response.ok) {
        let storeProductCollection = await response.json();
        return storeProductCollection.products;
      } else if (response.status === 404) {
        return [];
      } else {
        return [];
      }
    } catch (error) {
      console.log(error);
    } finally {
    }
  };

  return (
    <>
      <Template>
        <div style={{ height: "100%" }} className='HiddenChecksales'>
          {/*  <StoreNameandInfo /> */}
          {/* <StoreTabs switchPage={setPage} storeIsOnlineOnly={store.isOnlineStoreOnly} noProductCreated={noProductCreated} /> */}

          {store.isOnlineStoreOnly === false && page === "transaction" && isDbReady && (
            <CashTransaction openCheckSales={setOpenCheckSales} socket={socket} setOpenPromptToSync={setOpenPromptToSync} noProductCreated={noProductCreated} />
          )}
          {page === "receivedOrder" && <ReceivedOrder socket={socket} refetch={refetch} />}
          {page === "advertisement" && <AdvertismentHomePage />}
          {page === "stockManagement" && <StockHomePage setOpenCheckStock={setOpenCheckStock} socket={socket} />}
          {page === "messages" && <MessagesPage socket={socket} />}
          {page === "storeProfile" && <StoreDashboard />}
          {page === "expenses" && <ExpenseTracker />}
          {isLoading && <Spinner position={"absolute"} transparent={false} backgroundColor={"white"} loadingState={loadingState} />}
          {openCheckSales && <CheckSales closeModal={setOpenCheckSales} currency={user.userCountryCurrencySymbol} />}
          {openCheckStock && (
            <CheckStock closeModal={setOpenCheckStock} openModal={openCheckStock ? "ShowCheckStockWrapper" : ""} currency={user.userCountryCurrencySymbol} />
          )}
        </div>
        {showBlockNotification && reminderData && (
          <BlockNotification currency={user.userCountryCurrencySymbol} closeModal={setShowBlockNotification} data={reminderData} />
        )}
      </Template>
    </>
  );
};

export default StoreHome;
